import {
  CompensationConfigAllowanceTypes,
  CompensationConfigBonusTypes,
  CompensationConfigRecurrence,
  CompensationConfigTypes,
  CompensationSource,
  CompensationVariantPaymentState,
  type GetCompensationConfigResponseAPI,
  type GetCompensationVariantPaymentsResponseAPI,
} from '@omnipresentgroup/types';

import { DEFAULT_EMPLOYEE } from '../employees';

export const GET_CON_COMPENSATION_CONFIG_RESPONSE: GetCompensationConfigResponseAPI =
  {
    variant_payments_types: [
      {
        type: CompensationConfigTypes.BONUS,
        subtype: CompensationConfigBonusTypes.SIGN_ON_BONUS,
        name: 'Sign On Bonus',
        recurrence: [CompensationConfigRecurrence.ONE_OFF],
        mandatory: false,
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.CAR_ALLOWANCE,
        name: 'Car Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.COST_OF_LIVING_ALLOWANCE,
        name: 'Cost of Living Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.EDUCATION_ALLOWANCE,
        name: 'Education Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.END_OF_YEAR_ALLOWANCE,
        name: 'Christmas Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.HEALTH_ALLOWANCE,
        name: 'Health Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.HOLIDAY_ALLOWANCE,
        name: 'Holiday Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.HOUSING_ALLOWANCE,
        name: 'housing Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.MEAL_ALLOWANCE,
        name: 'Meal Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.PENSION_ALLOWANCE,
        name: 'Pension Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.PHONE_ALLOWANCE,
        name: 'Phone Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.REMOTE_ALLOWANCE,
        name: 'Remote Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: true,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.TRANSPORTATION_ALLOWANCE,
        name: 'Transportation Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.TRAVEL_ALLOWANCE,
        name: 'Travel Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.WELLNESS_ALLOWANCE,
        name: 'wellness Allowance',
        recurrence: [CompensationConfigRecurrence.MONTHLY],
        mandatory: false,
        range_min: '100',
        range_max: '1000',
      },
    ],
    source: CompensationSource.CONTRACTUAL,
    description:
      'This some description coming from Avvoka to help the user select optional allowances for example',
  };

export const GET_MOM_COMPENSATION_CONFIG_RESPONSE: GetCompensationConfigResponseAPI =
  {
    variant_payments_types: [
      {
        type: CompensationConfigTypes.BONUS,
        subtype: CompensationConfigBonusTypes.SIGN_ON_BONUS,
        name: 'Sign On Bonus',
        recurrence: [CompensationConfigRecurrence.ONE_OFF],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.CAR_ALLOWANCE,
        name: 'Car Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.COST_OF_LIVING_ALLOWANCE,
        name: 'Cost of Living Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.EDUCATION_ALLOWANCE,
        name: 'Education Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.END_OF_YEAR_ALLOWANCE,
        name: 'Christmas Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.HEALTH_ALLOWANCE,
        name: 'Health Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.HOLIDAY_ALLOWANCE,
        name: 'Holiday Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.HOUSING_ALLOWANCE,
        name: 'housing Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.MEAL_ALLOWANCE,
        name: 'Meal Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.PENSION_ALLOWANCE,
        name: 'Pension Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.PHONE_ALLOWANCE,
        name: 'Phone Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.REMOTE_ALLOWANCE,
        name: 'Remote Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.TRANSPORTATION_ALLOWANCE,
        name: 'Transportation Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.TRAVEL_ALLOWANCE,
        name: 'Travel Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.ALLOWANCE,
        subtype: CompensationConfigAllowanceTypes.WELLNESS_ALLOWANCE,
        name: 'wellness Allowance',
        recurrence: [
          CompensationConfigRecurrence.ONE_OFF,
          CompensationConfigRecurrence.MONTHLY,
        ],
      },
      {
        type: CompensationConfigTypes.COMMISSION,
        name: 'Commission',
        recurrence: [CompensationConfigRecurrence.ONE_OFF],
      },
    ],
    source: CompensationSource.MONTH_ON_MONTH,
  };

export const GET_COMPENSATION_VARIANT_PAYMENTS_RESPONSE: GetCompensationVariantPaymentsResponseAPI =
  [
    {
      id: 'employee_allowance_0',
      type: CompensationConfigTypes.ALLOWANCE,
      subtype: CompensationConfigAllowanceTypes.REMOTE_ALLOWANCE,
      name: 'Remote Allowance',
      company_id: '',
      employee_id: DEFAULT_EMPLOYEE.id,
      employee_name: DEFAULT_EMPLOYEE.name,
      user_id: '',
      amount: {
        amount: '500',
        currency: 'GBP',
      },
      effective_date: '2024-09-03',
      end_date: '2024-10-31',
      requested_at: '2024-09-03T11:07:20.619Z',
      requested_by_auth_id: '',
      recurrence: CompensationConfigRecurrence.MONTHLY,
      source: CompensationSource.CONTRACTUAL,
      state: CompensationVariantPaymentState.INACTIVE,
      reason: 'Required by contract',
      additional_notes: 'Here is some quick info about the allowance',
      is_mandatory: true,
      is_internal: false,
    },
    {
      id: 'employee_allowance_1',
      type: CompensationConfigTypes.ALLOWANCE,
      subtype: CompensationConfigAllowanceTypes.PHONE_ALLOWANCE,
      name: 'Phone Allowance',
      company_id: '',
      employee_id: DEFAULT_EMPLOYEE.id,
      employee_name: DEFAULT_EMPLOYEE.name,
      user_id: '',
      amount: {
        amount: '150',
        currency: 'GBP',
      },
      effective_date: '2024-09-03',
      requested_at: '2024-09-03T11:07:20.619Z',
      requested_by_auth_id: '',
      recurrence: CompensationConfigRecurrence.MONTHLY,
      source: CompensationSource.CONTRACTUAL,
      state: CompensationVariantPaymentState.ACTIVE,
      reason: 'Some description of the reason',
      is_mandatory: false,
      is_internal: false,
    },
    {
      id: 'employee_allowance_2',
      type: CompensationConfigTypes.ALLOWANCE,
      subtype: CompensationConfigAllowanceTypes.HOUSING_ALLOWANCE,
      name: 'Housing Allowance',
      company_id: '',
      employee_id: DEFAULT_EMPLOYEE.id,
      employee_name: DEFAULT_EMPLOYEE.name,
      user_id: '',
      amount: {
        amount: '400',
        currency: 'GBP',
      },
      effective_date: '2024-12-01',
      requested_at: '2024-09-03T11:07:20.619Z',
      requested_by_auth_id: '',
      recurrence: CompensationConfigRecurrence.MONTHLY,
      source: CompensationSource.CONTRACTUAL,
      state: CompensationVariantPaymentState.REQUESTED,
      reason: 'Some description of the reason',
      is_mandatory: false,
      is_internal: false,
    },
  ];
